export default __webpack_public_path__ + "static/media/DSCN2329.ea2a9b68.JPG";